import { useTranslation } from '@eon/i18n';
import { Badge } from '@eon/ui';
import { cn, formatKWh } from '@eon/utils';

interface AllowanceBalanceProps {
  value: number | null | undefined;
  className?: string;
}

export function AllowanceBalance({ value, className }: AllowanceBalanceProps) {
  const { t } = useTranslation();

  if (value == null) {
    return <span className={cn('text-muted-foreground', className)}>—</span>;
  }

  if (value < 0) {
    return (
      <div className={cn('flex items-center gap-2', className)}>
        <Badge variant="destructive">{t('portal.users.allowanceDebt')}</Badge>
        <span className="text-destructive font-semibold tabular-nums">{formatKWh(Math.abs(value))}</span>
      </div>
    );
  }

  if (value === 0) {
    return (
      <div className={cn('flex items-center gap-2', className)}>
        <Badge variant="warning">{t('portal.users.allowanceEmpty')}</Badge>
        <span className="text-muted-foreground tabular-nums">{formatKWh(0)}</span>
      </div>
    );
  }

  return (
    <span
      className={cn(
        'font-medium tabular-nums',
        value <= 10 && 'text-amber-700 dark:text-amber-300',
        className,
      )}
    >
      {formatKWh(value)}
    </span>
  );
}
